import {
    FALLBACK_LANGUAGE as fallbackLanguage,
    LANGUAGE as language
} from "../GlobalConfiguration.js"

/**
 * Returns text in set language (defined in global configuration).
 * If the text value is missing, returns fallback language value instead
 * @param jsonPath json path without array value of language
 * <p>(e.g. instead of <code>title["en"]</code> use <code>title</code>)</p>
 * @returns {*}
 */
function getText(jsonPath) {
    if(jsonPath[language] === undefined || jsonPath[language] === null){
        return jsonPath[fallbackLanguage];
    }

    return jsonPath[language];
}


export {getText};


// WEBPACK FOOTER //
// ./src/js/util/localization.js